import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaUserMd } from 'react-icons/fa';
import { MdAccessTime } from 'react-icons/md';
import './Features.css';

const Features = () => {
 // return (
    // <section className="features-section">
    //   <Container>
    //     <Row className="g-4">
    //       <Col md={6}>
    //         <div className="feature-card">
    //           <div className="feature-icon clock-icon">
    //             <MdAccessTime />
    //           </div>
    //           <div className="feature-content">
    //             <h3>24/7 support:</h3>
    //             <p>We are here for you at any time, ensuring peace of mind for families.</p>
    //           </div>
    //         </div>
    //       </Col>
    //       <Col md={6}>
    //         <div className="feature-card">
    //           <div className="feature-icon doctor-icon">
    //             <FaUserMd />
    //           </div>
    //           <div className="feature-content">
    //             <h3>Experienced Caregivers</h3>
    //             <p>Our team is trained, certified, and passionate about care.</p>
    //           </div>
    //         </div>
    //       </Col>
    //     </Row>
    //   </Container>
    // </section>
  //);
};

export default Features;
